import { ReactNode } from "react";

type NewlineBreakProps = {
  children: ReactNode;
};
// displays newline characters as linebreaks
export function NewlineBreak({ children }: NewlineBreakProps) {
  // whitespace-pre-wrap makes newline characters line-break.
  return <span className="whitespace-pre-wrap">{children}</span>;
}
